import * as types from "../actions/actionTypes";
import initialState from "./initialState";
import { CurrentMentorsActions } from "../actions/currentClientActions";
import { LiveSwitchAction } from "../../../LiveSwitch/liveSwitchActions";
import { Order, SetScheduleResult } from "../../../Shared/GeneratedTypes";
import * as LiveSwitchTypes from "../../../LiveSwitch/liveSwitchActionTypes";
import { DateTime } from "luxon";

export default function orderReducer(
    state = initialState.order,
    action: CurrentMentorsActions | LiveSwitchAction
): Order {
    switch (action.type) {
        case types.UPDATE_CULTURE_SUCCESS:
        case types.LOAD_CURRENT_MENTORS_BY_ID_SUCCESS: {
            return action.session.order;
        }
        case types.POLICY_HOLDER_PHOTO_CLEARED:
        case types.POLICY_HOLDER_PHOTO_SUCCESS: {
            let order = { ...state };
            order.contact = {
                ...order.contact,
                photoUrl: action.url,
            };
            return order;
        }
        case types.ENTERED_INTO_QUEUE_SUCCESS:
        case types.CHECK_QUEUE_PLACEMENT_SUCCESS: {
            if (action.queuePlacementResult.mentor) {
                return {
                    ...state,
                    assignedMentor: action.queuePlacementResult.mentor,
                    mentorActiveSince: DateTime.local(),
                    lastMentorHeartbeat: new Date(),
                    enqueuedDate: new Date(),
                };
            } else if (types.ENTERED_INTO_QUEUE_SUCCESS === action.type) {
                return { ...state, enqueuedDate: new Date() };
            }
            break;
        }

        case types.PRIVACY_STATEMENT_ACCEPTED: {
            return { ...state, acceptedPrivacyStatement: new Date() };
        }
        case types.SCHEDULE_SET_OPTIMISTIC: {
            return { ...state, scheduledDate: action.date };
        }
        case types.SCHEDULE_SET_FAILED: {

            if (action.result == SetScheduleResult.SessionCanceled) {
                return { ...state, expirationDate: DateTime.utc().minus({ "minutes": 1 }) }
            }

            return state;
        }

        case types.END_CLIENT_SESSION_SUCCESS: {
            let order = { ...state, clientSessionEnded: action.endDate } as Order;

            return order;
        }
        case LiveSwitchTypes.SESSION_ENDED_RECEIVED: {
            return { ...state, clientSessionEnded: new Date() };
        }
        case types.SAVE_FEEDBACK_OPTIMISTIC_COMPLETE: {
            return { ...state, clientFeedback: { ...(state.clientFeedback ?? {}), feedback: action.feedback } };
        }
        case types.SAVE_AUDIORATING_OPTIMISTIC_COMPLETE: {
            return {
                ...state,
                clientFeedback: { ...(state.clientFeedback ?? {}), audioRating: action.rating ?? undefined },
            };
        }
        case types.SAVE_VIDEORATING_OPTIMISTIC_COMPLETE: {
            return {
                ...state,
                clientFeedback: { ...(state.clientFeedback ?? {}), videoRating: action.rating ?? undefined },
            };
        }
        case types.SAVE_OVERALLRATING_OPTIMISTIC_COMPLETE: {
            return {
                ...state,
                clientFeedback: { ...(state.clientFeedback ?? {}), overallRating: action.rating ?? undefined },
            };
        }
        case types.OPT_OUT_OF_PORTRAIT_PHOTO_SUCCESS: {
            return {
                ...state,
                contact: { ...state.contact, optedOutOfPhoto: true },
            };
        }
        default:
            return state;
    }
    return state;
}
